
import { defineComponent } from "vue";
export default defineComponent({
  name: "Loader",

  props: {
    progress: { type: Number, default: 10 },
  },
});
